const Laptop = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.5 7A2.5 2.5 0 0 1 7 4.5h10A2.5 2.5 0 0 1 19.5 7v7a2.5 2.5 0 0 1-2.5 2.5H7A2.5 2.5 0 0 1 4.5 14zM7 5.5A1.5 1.5 0 0 0 5.5 7v7A1.5 1.5 0 0 0 7 15.5h10a1.5 1.5 0 0 0 1.5-1.5V7A1.5 1.5 0 0 0 17 5.5z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M4 19a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 0 1h-15A.5.5 0 0 1 4 19"
    />
  </>
)
export default Laptop
